var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAgenda(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#231F20;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.8,19c-1,0-1.7-0.8-1.7-1.7V8.1c0-1,0.8-1.7,1.7-1.7c1,0,1.7,0.8,1.7,1.7v9.2C40.6,18.2,39.8,19,38.8,19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.4,19c-1,0-1.7-0.8-1.7-1.7V8.1c0-1,0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7v9.2C22.1,18.2,21.3,19,20.4,19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.4,25.9H8.8c-1,0-1.7-0.8-1.7-1.7c0-1,0.8-1.7,1.7-1.7h41.5c1,0,1.7,0.8,1.7,1.7 C52.1,25.2,51.3,25.9,50.4,25.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.4,14.4c-1.6,0-2.9,1.3-2.9,2.9v30c0,1.6,1.3,2.9,2.9,2.9h32.3c1.6,0,2.9-1.3,2.9-2.9v-30 c0-1.6-1.3-2.9-2.9-2.9H13.4z M45.7,53.6H13.4c-3.5,0-6.3-2.8-6.3-6.3v-30c0-3.5,2.8-6.3,6.3-6.3h32.3c3.5,0,6.3,2.8,6.3,6.3v30 C52.1,50.8,49.2,53.6,45.7,53.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.1,34.5L18.1,34.5L18.1,34.5z M18.1,35.7c-1.3,0-2.3-1-2.3-2.3c0-1.3,1-2.3,2.3-2.3c0,0,0,0,0,0 c1.3,0,2.3,1,2.3,2.3C20.4,34.7,19.4,35.7,18.1,35.7L18.1,35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.6,34.5L29.6,34.5L29.6,34.5z M29.6,35.7c-1.3,0-2.3-1-2.3-2.3c0-1.3,1-2.3,2.3-2.3c0,0,0,0,0,0 c1.3,0,2.3,1,2.3,2.3C31.9,34.7,30.9,35.7,29.6,35.7L29.6,35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.2,34.5L41.2,34.5L41.2,34.5z M41.2,35.7c-1.3,0-2.3-1-2.3-2.3c0-1.3,1-2.3,2.3-2.3c0,0,0,0,0,0 c1.3,0,2.3,1,2.3,2.3C43.5,34.7,42.4,35.7,41.2,35.7L41.2,35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.1,43.8L18.1,43.8L18.1,43.8z M18.1,44.9c-1.3,0-2.3-1-2.3-2.3c0-1.3,1-2.3,2.3-2.3c0,0,0,0,0,0 c1.3,0,2.3,1,2.3,2.3C20.4,43.9,19.4,45,18.1,44.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.6,43.8L29.6,43.8L29.6,43.8z M29.6,44.9c-1.3,0-2.3-1-2.3-2.3c0-1.3,1-2.3,2.3-2.3c0,0,0,0,0,0 c1.3,0,2.3,1,2.3,2.3C31.9,43.9,30.8,45,29.6,44.9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAgenda);
export default __webpack_public_path__ + "static/media/ic_agenda.78ba32cea607ab9c9475768d428cc5c2.svg";
export { ForwardRef as ReactComponent };